import { render, staticRenderFns } from "./product-detail-route-ports.vue?vue&type=template&id=f50958e8&scoped=true&"
import script from "./product-detail-route-ports.vue?vue&type=script&lang=js&"
export * from "./product-detail-route-ports.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-route-ports.vue?vue&type=style&index=0&id=f50958e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50958e8",
  null
  
)

export default component.exports